import { getLocale } from "../runtime";

const da_couponcodeplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `f.eks. GLIMJA20`
};

const en_couponcodeplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `e.g. GLIMJA20`
};

const es_couponcodeplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `p.ej. GLIMJA20`
};

const fi_couponcodeplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `esim. GLIMJA20`
};

const nb_couponcodeplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `f.eks. GLIMJA20`
};

const sv_couponcodeplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `t.ex. GLIMJA20`
};

const couponcodeplaceholder = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_couponcodeplaceholder(inputs)
	if (locale === "en") return en_couponcodeplaceholder(inputs)
	if (locale === "es") return es_couponcodeplaceholder(inputs)
	if (locale === "fi") return fi_couponcodeplaceholder(inputs)
	if (locale === "nb") return nb_couponcodeplaceholder(inputs)
	if (locale === "sv") return sv_couponcodeplaceholder(inputs)
	return "couponCodePlaceholder";
};

export { couponcodeplaceholder as "couponCodePlaceholder" };